<div class="customers-content-area">
  <xproj-dashboard #dashboardOverview [editMode]="false" [showDashboardSettings]="false"
    [systemDashboard]="true" [dashboardId]="dashboardId" [enableExport]="false"
    [dashboardTag]="'latest'" [responsiveWidth]="responsiveWidth"
    [dashboardOutputParameters]="dashboardOutputParameters"
    (onWidgetValueSelected)="meterDashboardValueChanged($event)"></xproj-dashboard>
</div>
